const topFirst = (() => {
  if (document.querySelector("body#pageTop") !== null) {



    let secFirst = document.querySelector('#jsSecFirst');

    let effectWrap = secFirst.querySelector('.js-effect-wrap');
    let effect = effectWrap.querySelector('.js-effect');

    setTimeout(() => {
      effect.classList.add('is-act')

      setTimeout(() => {
        secFirst.classList.add('is-none')
      }, 3000);
    }, 300);



  }
})()
export default topFirst;